module.exports = __webpack_public_path__ + "img/xp_icon_jx01.png";